<div
  [style.background-color]="getColor(student())"
  class="avatar text-white relative inline-flex items-center justify-center overflow-hidden rounded-full"
>
  @if (!student().profile_picture_url || !student().has_profile_picture) {
  <div
    [style.background-color]="getColor(student())"
    class="relative inline-flex items-center justify-center w-10 h-10 overflow-hidden rounded-full"
  >
    <span class="font-medium text-white dark:text-gray-300">{{
      student().forename?.substring(0, 1)
    }}</span>
  </div>
  } @else {
  <ion-thumbnail slot="start" class="w-10 h-10 grid relative">
    <img
      [ngSrc]="student().profile_picture_url"
      fill
      class="image relative"
      [alt]="student().forename?.substring(0, 1)"
    />
  </ion-thumbnail>
  }
</div>
